import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.links}>
        <a href="https://peapilpublishing.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer" className={styles.link}>
          Terms
        </a>
        <span className={styles.divider}>|</span>
        <Link to="/privacy" className={styles.link}>
          Privacy
        </Link>
        <span className={styles.divider}>|</span>
        <Link to="/legal" className={styles.link}>
          Legal
        </Link>
        <span className={styles.divider}>|</span>
        <Link to="/faq" className={styles.link}>
          FAQ
        </Link>
      </div>
      <p className={styles.copyright}>© {new Date().getFullYear()} Peapil Health. All rights reserved.</p>
    </footer>
  );
}
